/*!
 * devextreme-angular
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { SortOrder } from 'devextreme/common';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { CollectionNestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxi-data-grid-sort-by-group-summary-info',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxiDataGridSortByGroupSummaryInfoComponent extends CollectionNestedOption {
    @Input()
    get groupColumn(): string | undefined {
        return this._getOption('groupColumn');
    }
    set groupColumn(value: string | undefined) {
        this._setOption('groupColumn', value);
    }

    @Input()
    get sortOrder(): SortOrder | undefined {
        return this._getOption('sortOrder');
    }
    set sortOrder(value: SortOrder | undefined) {
        this._setOption('sortOrder', value);
    }

    @Input()
    get summaryItem(): number | string | undefined {
        return this._getOption('summaryItem');
    }
    set summaryItem(value: number | string | undefined) {
        this._setOption('summaryItem', value);
    }


    protected get _optionPath() {
        return 'sortByGroupSummaryInfo';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  declarations: [
    DxiDataGridSortByGroupSummaryInfoComponent
  ],
  exports: [
    DxiDataGridSortByGroupSummaryInfoComponent
  ],
})
export class DxiDataGridSortByGroupSummaryInfoModule { }
